"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlusIcon16Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.PlusIcon16Solid = forwardRef_1.forwardRef('PlusIcon16Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 16 }, props),
        react_1.default.createElement("path", { d: "M7.5 2A1.5 1.5 0 0 1 9 3.5V7h3.5a1.5 1.5 0 0 1 0 3H9v3.5a1.5 1.5 0 0 1-3 0V10H2.5a1.5 1.5 0 1 1 0-3H6V3.5A1.5 1.5 0 0 1 7.5 2Z" })));
});
